import { useCallback } from "react";
import TechpackService from "../service/TechpackService";

export const useTechpackFetcher = () => {
  //Will fetch techpack of the order request with colors expanded and with decorations' assets' urls
  const fetchPreOrderTechpack = useCallback(async (preorderId: string) => {
    const res = await TechpackService.getPreOrderTechpack({
      preorderId,
      includeImagesUrl: true,
    });

    return res.data.data;
  }, []);

  const fetchTechpackPdfLink = useCallback(
    async (techpackId: string, techpackItemIds: string[]) => {
      const res = await TechpackService.getTechpackPdfLink({
        techpackId,
        techpackItemIds,
      });

      return res.data.data;
    },
    []
  );

  return {
    fetchPreOrderTechpack,
    fetchTechpackPdfLink,
  };
};
